import { useState, useCallback, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  IconButton,
  Popover,
  Badge,
  Tooltip,
} from '@mui/material';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useTranslation } from 'react-i18next';
import GlobalFiltersPannel from '../../GlobalFiltersPannel';
import { authActions } from '../../../store/slices/authSlice';
import { OrderSearchActions } from '../../../pages/Orders/store/slice/OrdersSlice';
import { doSearchStoreActionHandler as orderSearchAction } from '../../../pages/Orders/store/action/OrdersActions';
import { orderRequestActions } from '../../../pages/OrderRequest/store/slice/OrderRequestSlice';
import { doSearchStoreActionHandler as orderRequestSearchAction } from '../../../pages/OrderRequest/store/action/OrderRequestActions';
import { cylinderSearchActions } from '../../../pages/cylinders/store/slices/cylinderSearchSlice';
import { doSearchStoreActionHandler as cylinderSearchAction } from '../../../pages/cylinders/store/actions/cylinderSearchActions';
import { useLocation } from 'react-router-dom';
import { getClientIdsByScreenAccess } from '../../../utils/screenPermission';
import useAuth from '../../../hooks/useAuth';
import { isEmpty } from 'lodash';
import toast from 'react-hot-toast';
// import { searchActions } from '../../../pages/Actions/store/actions/actionsSearchActions';

const initialFilterState = [
  {
    Fields: [
      { Field: 'clientIDs', Value: [] },
      { Field: 'reportAddressIDs', Value: [] },
      { Field: 'ScenarioID', Value: [] },
      { Field: 'active', Value: true },
      { Field: 'Active', Value: true },
      // { Field: 'UserType', Value: [{ id: 'BV', text: 'BV' }, { id: 'Client', text: 'Client' }, { id: 'Supplier', text: 'Supplier' }] },
    ]
  }
];
const actionMap = {
  Orders: {
    applySavedFilter: OrderSearchActions.applySavedFilter,
    doSearch: orderSearchAction,
  },
  OrderRequest: {
    applySavedFilter: orderRequestActions.applySavedFilter,
    doSearch: orderRequestSearchAction,
  },
  Cylinders: {
    applySavedFilter: cylinderSearchActions.applySavedFilter,
    doSearch: cylinderSearchAction,
  }
};

function getFilterAccessClientByScreenOnly(data, clientIDs) {
  const idsToFind = clientIDs.map((id) => Number(id));

  return data.map((item) => {
    if (item.Field === 'clientIDs' && Array.isArray(item.Value)) {
      return {
        ...item,
        Value: item.Value.filter((client) =>
          idsToFind.includes(client.ClientID))
      };
    }

    // Return other fields as-is
    return item;
  });
}
const GlobalFilterPopover = () => {
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const { userToRoles } = useAuth();
  const { tasks } = useSelector((state) => state.activityCenter);
  const loginUser = useSelector((state) => state.auth.loginUser);
  const userGlobalFilterPetroHub = loginUser?.userGlobalFilterPetroHub;
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const { t: translate } = useTranslation();
  const location = useLocation();

  const pageName = useMemo(() => location.pathname.split('/').filter(Boolean)[0], [location]);
  useEffect(() => {
    if (userGlobalFilterPetroHub && userGlobalFilterPetroHub.length > 0 && !isFilterApplied && userGlobalFilterPetroHub[0].Fields && userGlobalFilterPetroHub[0].Fields.length > 0 && userGlobalFilterPetroHub[0].Fields.some((f) => f.Value && f.Value.length > 0)) {
      // Initialize with default filter if not present
      console.log('Applying global filter from localStorage:', userGlobalFilterPetroHub);
      // const { Fields } = userGlobalFilterPetroHub[0];
      // const clientIDs = getClientIdsByScreenAccess(userToRoles, pageName);
      setIsFilterApplied(true);
    }
  }, [userGlobalFilterPetroHub, isFilterApplied]);

  // ✅ FIX 2: Stable function with proper state update
  const setUserGlobalFilterPetroHub = useCallback((value) => {
    window.localStorage.setItem('userGlobalFilterPetroHub', JSON.stringify(value));
    dispatch(authActions.updateUserGlobalFilterPetroHub(value));
    setAnchorEl(null);
  }, [dispatch]);

  const dispatchApplySavedFilter = useCallback((filteredFields) => {
    dispatch(actionMap.Orders.applySavedFilter(filteredFields));
    dispatch(actionMap.Orders.doSearch());
    dispatch(actionMap.OrderRequest.applySavedFilter(filteredFields));
    dispatch(actionMap.OrderRequest.doSearch());
    dispatch(actionMap.Cylinders.applySavedFilter(filteredFields));
    dispatch(actionMap.Cylinders.doSearch());
  }, [dispatch]);

  const onResetFilterHandler = useCallback(() => {
    window.localStorage.removeItem('userGlobalFilterPetroHub');
    setAnchorEl(null);
    setIsFilterApplied(false);
    console.log('Resetting filter to initial state:', initialFilterState);
    dispatch(authActions.updateUserGlobalFilterPetroHub(initialFilterState));
    const pageActions = actionMap[pageName];
    const { Fields } = initialFilterState[0];
    if (pageActions) {
      // dispatch(pageActions.applySavedFilter(Fields));
      // dispatch(pageActions.doSearch());
      dispatchApplySavedFilter(Fields);
    }
  }, [dispatch, pageName, dispatchApplySavedFilter]);

  const onSaveFilterHandler = useCallback(async (value) => {
    // Update localStorage after state change
    if (value && value.length > 0 && value[0].Fields && value[0].Fields.length > 0 && value[0].Fields.some((f) => f.Value && f.Value.length > 0)) {
      // console.log('Saving filter:', value);
      const { Fields } = value[0];
      // const pageActions = actionMap[pageName];
      // console.log('Client IDs from screen access:', pageName);
      // if (pageActions) {
      const clientIDs = getClientIdsByScreenAccess(userToRoles, pageName);
      // console.log('Client IDs for screen access:', clientIDs);
      const filteredFields = clientIDs.length > 0 ? getFilterAccessClientByScreenOnly(Fields, clientIDs) : Fields;
      // console.log('#filteredFields:', filteredFields);
      if (!isEmpty(filteredFields)) {
        setUserGlobalFilterPetroHub(value);
        setIsFilterApplied(true);
        dispatchApplySavedFilter(filteredFields);
        // dispatch(pageActions.applySavedFilter(filteredFields));
        // dispatch(pageActions.doSearch());
      }
      // }
    } else {
      // If value is empty, treat it as reset
      // onResetFilterHandler();
      toast.error(translate('Info_Message_NoGlobalFilterToApply'));
    }
  }, [pageName, setUserGlobalFilterPetroHub, userToRoles, onResetFilterHandler, dispatchApplySavedFilter]);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClear = () => {
    // dispatch(activityCenterActions.clearAllTasks());
  };
  const hasCompletedTasks = tasks.some((task) => task.isCompleted);

  return (
    <>
      <Tooltip title={translate('Tooltip_Filters')}>
        <IconButton onClick={handleOpen} color="primary" size="large">
          <Badge
            color="secondary"
          >
            {isFilterApplied && <FilterAltIcon fontSize="small" color="primary" />}
            {!isFilterApplied && <FilterAltOutlinedIcon fontSize="small" color="action" />}
          </Badge>
        </IconButton>
      </Tooltip>

      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{
          mt: 1,
        }}
        slotProps={{
          paper: {
            sx: {
              width: '50%'
            }
          }
        }}
      >
        <GlobalFiltersPannel
          tasks={tasks}
          onClose={handleClose}
          onClear={handleClear}
          hasCompletedTasks={hasCompletedTasks}
          userGlobalFilterPetroHub={userGlobalFilterPetroHub || initialFilterState}
          onResetFilterHandler={onResetFilterHandler}
          onSaveFilterHandler={onSaveFilterHandler}
        />
      </Popover>
    </>
  );
};

export default GlobalFilterPopover;
